export enum OnDemandRoutes {
  CalibrationRebuild = 'calibration/rebuild',
  CalibrationReset = 'calibration/reset',
  FindManyMss = 'machine-states/find-many',
  FindManyMssByBsHash = 'machine-states/find-many-by-bs-hash',
  GetLatestCalibration = 'calibration/latest',
  UpsertOneMs = 'machine-states/upsert-one',
}
